import axios from '@/config/axios'

const facilityTypeBase = '/v1/api/mg/facilityType'

export const facilityTypes = () => axios.get(facilityTypeBase)

export const facilityTypesDelete = (id) => axios.delete(`${facilityTypeBase}/${id}`)

export const facilityTypesUpdate = (data) => axios.put(`${facilityTypeBase}/${data.id}`, data)

export const facilityTypesCreate = (data) => axios.post(facilityTypeBase, data)

const facilityBase = '/v1/api/mg/facility'

export const facility = () => axios.get(facilityBase)

export const facilityDelete = (id) => axios.delete(`${facilityBase}/${id}`)

export const facilityUpdate = (data) => axios.put(`${facilityBase}/${data.id}`, data)

export const facilityCreate = (data) => axios.post(facilityBase, data)


const facilityOrderBase = '/v1/api/mg/facilityBooking'


export const facilityOrders = (query) => axios.get(`${facilityOrderBase}`, {
    params: query, headers: {"request": "dto"}
})


export const exportFacilityOrders = (query) => axios.get(`${facilityOrderBase}`, {
    params: query,
    headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
});

export const facilityOrderNoRefund = (id) => axios.patch(`${facilityOrderBase}/${id}/noRefund`)


const facilityBlockedBase = '/v1/api/mg/facilityBlocked'

export const facilityBlocked = (query) => axios.get(facilityBlockedBase, {params: query})

export const facilityBlockedDelete = (id) => axios.delete(`${facilityBlockedBase}/${id}`)


export const facilityBlockedCreate = (data) => axios.post(facilityBlockedBase, data)
